import { Collection } from "../../../entity/Collection";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { CollectionDto } from "../../dto/Collection.Dto";
import { mapToCollection } from "../../mapper/CollectionMapper";

class WSCollection {
  private static instance: WSCollection;

  private constructor() {}

  static getInstance(): WSCollection {
    if (!this.instance) {
      this.instance = new WSCollection();
    }
    return this.instance;
  }

  async createCollections(collection: Collection) {
    try {
      const url = ROUTES.COLLECTIONS + ROUTES.CREATE;
      const response = await fetchAPI({
        url,
        method: Method.POST,
        isAuthenticated: true,
        params: collection,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getCollections(companyId: string): Promise<Collection[]> {
    try {
      const url = ROUTES.COLLECTIONS + companyId;
      const response = await fetchAPI<CollectionDto[]>({
        url,
        method: Method.GET,
        isAuthenticated: true,
      });
      return mapToCollection(response.data);
    } catch (error) {
      throw error;
    }
  }
}

export const WSCollectionInstance = WSCollection.getInstance();
